module.exports = __webpack_public_path__ + "assets/img/btn-download-pc-9449ab2a.png";